﻿import { AxiosHttpClient } from '@antecipa/core/http/HttpClients';

export const NotificationApiService = () => {
  const client = AxiosHttpClient(import.meta.env.VITE_NOTIFICATION_URL);

  function unsubscribe(token) {
    return client.makeRequest({
      url: '/unsubscribe',
      method: 'POST',
      params: {
        token,
      },
    });
  }

  return {
    unsubscribe,
  };
};
